<template>
  <div class="text-4xl text-white text-center h-64 grid place-items-center tracking-wide uppercase">
    Good bye Eddie, you were the best!
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({})
export default class Hero extends Vue {}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
